// extracted by mini-css-extract-plugin
module.exports = {"applyFailedDetails":"index-module_applyFailedDetails_ai_Nb","applyNewCredit":"index-module_applyNewCredit_2r6RO","applyNewCreditButton":"index-module_applyNewCreditButton_37K4C"};